import styled from "styled-components";

export const SelectInput = styled.input`
  outline: none;
  height: 46px;
  width: 100%;
  text-align: center;
  border: 1px solid #989898;
  border-radius: 12px;
  font-weight: 400;
  color: #545454;
  box-sizing: border-box;
  caret-color: #ffffff; // cor do cursor
  cursor: pointer;

  ::placeholder {
    color: black;
    text-align: center;
  }

  :disabled {
    ${(props) => {
      if (props.hasError) {
        return `border-color: red;`;
      }
    }}

      ::placeholder {
      ${(props) => {
        if (props.hasError) {
          return `color: red;
          font-weight: 600;`;
        }
      }}
      text-align: center;
    }
  }
`;

export const DropDown = styled.div`
  /* width: 100%; // mesma largura do input */
  background-color: #fff;
  border-radius: 5px;
  margin-top: 2px; // distância do input
  border: 0.5px solid #ddd;
  height: 180px; // tamanho da caixa de seleção
  overflow: auto; // coloca os itens dentro com scroll
  
  box-shadow: 0 25px 15px rgb(0 0 0 / 0.1), 0 5px 20px rgb(0 0 0 / 0.1);

  ${(props) => {
    if (props.dropSelect) {
      return `display: block;`;
    } else {
      return `display: none;`;
    }
  }}

  ::-webkit-scrollbar {
    // #1d1d1d
    background-color: ${(props) => `${props.scrollBgColor}`}; /* Cor de fundo do "thumb" */
    width: 12px; // largura do scroll
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #f5f6f1; /* Cor de fundo do "thumb" */
    border-radius: 12px; /* Raio do "thumb" */
  }
`;

export const FocusedItem = styled.div`
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0px 5px;
  box-sizing: border-box;
  transition: 0.2s;
  cursor: pointer;

  :hover {
    background-color: ${(props) => `${props.overColor}`}; // cor que muda ao passar o mouse por cima
    color: #ffffff; // cor da letra por cima
    padding-bottom: 7px;
    transition: 0.2s;
  }
`;

export const LoaderStyle = styled.div`
  height: 140px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
